import styled from 'styled-components';
import {Link as LinkR} from 'react-router-dom';
import {Link as LinkS} from 'react-scroll';

interface NavProps {
    scrollNav: boolean;
}

export const Nav = styled.nav<NavProps>`
    background: ${({scrollNav}) => (scrollNav ? '#000' : 'transparent')};
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease-in-out;
    }
`;

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`
    color: #df2935;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-left: 24px;
    font-weight: bold;
    text-decoration: none;
    background: transparent;
`;

export const MobileIcon = styled.button`
    display: none;
    background: transparent;
    border: 0;
    padding: 0;

    @media screen and (max-width: 820px) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
        color: #df2935;
    }

    &:focus-visible {
        outline: 2px solid #df2935;
        outline-offset: 4px;
    }
`;

export const MobileLanguage = styled.div`
    display: none;

    @media screen and (max-width: 820px) {
        display: flex;
        align-items: center;
        margin-right: 3.25rem;
    }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;

    @media screen and (max-width: 820px) {
        display: none;
    }
`;

export const NavItem = styled.li`
    height: 50px;
    font-weight: bolder;
    display: flex;
    align-items: center;
`;

export const NavLinks = styled(LinkS)`
    color: #df2935;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &.active {
        border-bottom: 5px solid #df2935;
        color: #fff;
    }

    &:hover {
        color: #fff;
    }
`;
